import { Col, Container, Row, Button, Card, CardBody } from "reactstrap";
import { Link as LinkScroll } from 'react-scroll';
import ReactPlayer from 'react-player';
import logoSoal from '../../../assets/images/game/w2_assets/Questionbar.png'
import Pilihan1 from '../../../assets/images/game/w2_soal/no-7/Add-a-subheading-3-1.png'
import btnCekNilai from '../../../assets/images/game/w2_buttons/Cek-Nilai.png'

import AnswerTrue from '../../../assets/images/game/w2_soal/no-7/SOAL NO 7. TUTORIAL GAMBAR.mp4'
import AssetPlanet from '../../../assets/images/game/w2_assets/asset-planet.png';
import AssetPlanet2 from '../../../assets/images/game/w2_assets/asset-planet-2.png';
import AssetAwan from '../../../assets/images/game/w2_assets/asset-awan.png';
import AssetAwan2 from '../../../assets/images/game/w2_assets/asset-awan-2.png';
import { useContext, useState } from "react";
import { Context } from "../../../contexts/reducer/store";
import CheckAnswer from "../CheckAnswer";
import { Link } from "react-router-dom";
import Left from '../../../assets/images/game/w2_assets/question-title-left.png';
import Right from '../../../assets/images/game/w2_assets/question-title-right.png';
import Video from '../../../assets/video/no-7.mp4';

const Soal8 = () => {

    let [isOpen, setIsOpen] = useState(false)
    let [isTrue, setIsTrue] = useState(false)

    const [state, dispatch] = useContext(Context);
    const [disabled, setDisabled] = useState(false) 

    function toggleModal ( type ) {
        setIsOpen(!isOpen);
        setIsTrue(type);
        setDisabled(true);
    }

    function SET_MARK ( value = Number ) {
        const init = {...state};
        let __mark = init.mark
        dispatch({type: 'SET_MARK', payload: __mark + value});
    }

    function handleResult() {
        console.log(state.mark);
    }

    const Answer = () => {
        return (
            <>
                <div className={`text-center`}>
                    {
                        isTrue 
                        ? (
                            <>
                                <div  className="text-center">
                                    <p>
                                        Kamu bisa tonton video tutorial cek fakta klaim hoaks <br /> 
                                        berupa gambar/ video selengkapnya di bawah ini. <br />
                                        <br />
                                        Selamat Menonton!
                                    </p>
                                </div>
                            </>    
                        ) 
                        : (
                            <>
                            <div className="text-center">
                                <p>
                                    Urutan yang kamu pilih belum benar nih... <br /> Mau tau urutan teknik yang benar?
                                    <br /><br />
                                    Yuk, tonton video tutorial cek fakta  klaim hoaks <br />
                                    berupa gambar/ video di bawah ini. Selamat Menonton!
                                </p>
                            </div>
                            </>
                        )
                    }
                </div>

                <ReactPlayer
                    className='react-player'
                    url={Video}
                    width='100%'
                    height='60vh'
                    playing={true}
                    loop={true}
                    controls={true}
                />
                <div className={`bg-light-green text-center py-1 ${isTrue ? 'd-none' : 'd-block'} my-3`}>
                    Jawaban yang benar pada soal adalah <b>2-3-5-4-6-1.</b>
                </div>
            </>
        )
    }

    return (
        <>
                <Container className="py-5 position-relative front">
                    <CheckAnswer Type={isTrue} isOpen={isOpen} setIsOpen={setIsOpen}>
                        <Answer />
                    </CheckAnswer>
                    <Row>
                        <Col md="12" className="text-center game-px">
                            <Row className="mb-5">
                                <Col lg="1" md="1" sm="1" xs="1" className="p-0 my-auto">
                                    <img src={Left} alt="" />
                                </Col>
                                <Col lg="10" md="10" sm="10" xs="10" className="my-auto">
                                    <Card className="card-title-quiz front">
                                        <CardBody>
                                            <h2 className="montserrat text-white">
                                                JIKA INGIN MELAKUKAN PENELUSURAN MANDIRI, MANAKAH <b>URUTAN PENELUSURAN KLAIM GAMBAR</b> DI ATAS YANG BENAR?
                                            </h2>
                                        </CardBody>
                                    </Card>
                                </Col>
                                <Col lg="1" md="1" sm="1" xs="1" className="p-0 my-auto">
                                    <img src={Right} alt="" />
                                </Col>
                            </Row>
                            <Row className="mb-3">
                                <Col md="12">
                                    <Card className="card-game">
                                        <CardBody>
                                            <Row>
                                                <Col className="">
                                                    <img src={Pilihan1} alt="Klaim Hoaks" className="w-100" />
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                            {
                                disabled === false 
                                ? <Row className="pt-3">
                                        <Col md="4" className="mx-auto text-center p-0 pt-3">
                                            <LinkScroll to="result" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(false))}>6-2-5-3-4-1</LinkScroll>
                                        </Col>
                                        <Col md="4" className="mx-auto text-center p-0 pt-3">
                                            <LinkScroll to="result" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(true), SET_MARK(1))}>2-3-5-4-6-1</LinkScroll>
                                        </Col>
                                        <Col md="4" className="mx-auto text-center p-0 pt-3">
                                            <LinkScroll to="result" spy={true} smooth={true} className="btn btn-jawaban montserrat" onClick={() => (toggleModal(false))}>1-3-5-2-4-6</LinkScroll>
                                        </Col>
                                    </Row>
                                : <Row className="pt-3">
                                        <Col md="4" className="mx-auto text-center p-0 pt-3">
                                            <button className="btn btn-jawaban montserrat" disabled>6-2-5-3-4-1</button>
                                        </Col>
                                        <Col md="4" className="mx-auto text-center p-0 pt-3">
                                            <button className="btn btn-jawaban montserrat" disabled>2-3-5-4-6-1</button>
                                        </Col>
                                        <Col md="4" className="mx-auto text-center p-0 pt-3">
                                            <button className="btn btn-jawaban montserrat" disabled>1-3-5-2-4-6</button>
                                        </Col>
                                    </Row>
                            }
                        </Col>
                    </Row>
                    <Row id="result">
                        <Col md="6" className="mx-auto pt-5">
                            <Link to="/result" className="border-0 bg-transparent">
                                <img src={btnCekNilai} className="w-100" />
                            </Link>
                        </Col>
                    </Row>
                </Container>
                <div className="position-relative img-asset">
                    <img src={AssetPlanet} alt="" className="asset-planet" />
                    <img src={AssetPlanet2} alt="" className="asset-planet-2" />
                    <img src={AssetAwan} alt="" className="asset-awan" />
                    <img src={AssetAwan2} alt="" className="asset-awan-2" />
                </div>
        </>
    )
}

export default Soal8